export default __webpack_public_path__ + "assets/1c1dda7c81bb9db8ae1c41b5192a216b/07.jpg";